<template>
  <div>
  <v-dialog
    :value="value"
    max-width="920"
    scrollable
    content-class="lk-broadcasts-dialog"
    @input="$emit('input', $event)"
  >
    <v-card class="lk-broadcasts-dialog__card">
      <v-card-title class="lk-broadcasts-dialog__title">
        <div class="d-flex align-center flex-grow-1 flex-wrap">
          <v-icon color="primary" class="mr-2">mdi-bell-cog-outline</v-icon>
          <span>История рассылок</span>
          <v-chip v-if="broadcasts.length" x-small class="ml-2" color="grey lighten-3">
            {{ broadcasts.length }}
          </v-chip>
        </div>
        <v-btn
          color="error"
          outlined
          small
          rounded
          class="text-none mr-2"
          :loading="deletingOld"
          :disabled="broadcastsLoading || !fullyReadBroadcastsCount"
          @click="openDeleteReadConfirm"
        >
          <v-icon left small>mdi-delete-sweep</v-icon>
          Удалить полностью прочитанные все сообщения
        </v-btn>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="lk-broadcasts-dialog__body pa-0">
        <div v-if="broadcastsLoading" class="text-center py-10">
          <v-progress-circular indeterminate color="primary" />
          <p class="caption grey--text mt-3 mb-0">Загрузка рассылок…</p>
        </div>

        <div v-else-if="!broadcasts.length" class="text-center py-10 px-4">
          <v-icon size="56" color="grey lighten-1">mdi-bell-off-outline</v-icon>
          <p class="mt-3 mb-0 grey--text">Нет опубликованных рассылок</p>
        </div>

        <v-expansion-panels v-else accordion class="lk-broadcasts-dialog__panels">
          <v-expansion-panel
            v-for="item in broadcasts"
            :key="recordId(item) || item.broadcast_id || item.title"
          >
            <v-expansion-panel-header class="lk-broadcasts-dialog__panel-header">
              <div class="lk-broadcasts-dialog__panel-header-inner">
                <div class="lk-broadcasts-dialog__panel-summary">
                  <div class="d-flex align-center flex-wrap">
                    <v-icon
                      small
                      :color="typeIconColor(item.type)"
                      class="mr-2"
                    >
                      {{ typeIcon(item.type) }}
                    </v-icon>
                    <span class="font-weight-medium">{{ item.title }}</span>
                    <v-chip
                      v-if="typeLabel(item.type)"
                      x-small
                      label
                      outlined
                      :color="typeChipColor(item.type)"
                      class="ml-2 lk-broadcasts-dialog__type-chip"
                    >
                      {{ typeLabel(item.type) }}
                    </v-chip>
                  </div>
                  <div class="caption grey--text mt-1 d-flex flex-wrap align-center">
                    <span>{{ formatDate(item.created_at) }}</span>
                    <v-chip
                      x-small
                      :color="readStatusColor(item)"
                      :text-color="readStatusTextColor(item)"
                      class="ml-2"
                      label
                    >
                      {{ readStatusText(item) }}
                    </v-chip>
                  </div>
                </div>
                <v-btn
                  icon
                  small
                  color="error"
                  class="ml-2 flex-shrink-0"
                  :loading="deletingId === recordId(item)"
                  :disabled="!recordId(item)"
                  @click.stop="openDeleteOneConfirm(item)"
                >
                  <v-icon small>mdi-delete-outline</v-icon>
                </v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="lk-broadcasts-dialog__details">
                <div class="lk-broadcasts-dialog__detail-row">
                  <span class="lk-broadcasts-dialog__detail-label">Заголовок</span>
                  <span>{{ item.title }}</span>
                </div>
                <div class="lk-broadcasts-dialog__detail-row">
                  <span class="lk-broadcasts-dialog__detail-label">Текст</span>
                  <span class="lk-broadcasts-dialog__detail-text">{{ item.body }}</span>
                </div>
                <!-- <div class="lk-broadcasts-dialog__detail-row">
                  <span class="lk-broadcasts-dialog__detail-label">Получатели</span>
                  <span>{{ formatRecipientsFull(item.recipients) }}</span>
                </div> -->
                <div class="lk-broadcasts-dialog__detail-row">
                  <span class="lk-broadcasts-dialog__detail-label">Получателей</span>
                  <span>{{ recipientsCount(item) }}</span>
                </div>
                <div class="lk-broadcasts-dialog__detail-row">
                  <span class="lk-broadcasts-dialog__detail-label">Прочитали</span>
                  <span>{{ readCount(item) }}</span>
                </div>
                <div class="lk-broadcasts-dialog__detail-row">
                  <span class="lk-broadcasts-dialog__detail-label">Не прочитали</span>
                  <span>{{ unreadCount(item) }}</span>
                </div>
                <div class="lk-broadcasts-dialog__detail-row">
                  <span class="lk-broadcasts-dialog__detail-label">Дата</span>
                  <span>{{ formatDate(item.created_at) }}</span>
                </div>
                <div v-if="item.broadcast_id" class="lk-broadcasts-dialog__detail-row">
                  <span class="lk-broadcasts-dialog__detail-label">ID рассылки</span>
                  <span class="caption grey--text text--darken-1">{{ item.broadcast_id }}</span>
                </div>
                <v-btn
                  color="error"
                  outlined
                  small
                  rounded
                  class="text-none mt-2"
                  :loading="deletingId === recordId(item)"
                  :disabled="!recordId(item)"
                  @click="openDeleteOneConfirm(item)"
                >
                  <v-icon left small>mdi-delete</v-icon>
                  Удалить
                </v-btn>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-dialog v-model="confirmDialog" max-width="480" persistent>
    <base-delete-modal
      :message-title="confirmTitle"
      :message-text="confirmText"
      :confirm-text="confirmSubmitText"
      confirm-color="error"
      confirm-icon="mdi-delete"
      @close="confirmDialog = false"
      @submit="confirmAction"
    />
  </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BaseDeleteModal from '@/components/BaseDeleteModal.vue';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import {
  LK_NOTIFICATION_ROLE_OPTIONS,
  getNotificationTypeChipColor,
  getNotificationTypeColor,
  getNotificationTypeIcon,
  getNotificationTypeLabel,
  resolveLkNotificationId,
  formatBroadcastReadStatus,
  getBroadcastReadStatusColor,
  isBroadcastFullyRead,
} from '@/constants/lk-notifications';

const ROLE_LABEL_BY_VALUE = LK_NOTIFICATION_ROLE_OPTIONS.reduce((acc, role) => {
  acc[role.value] = role.text;
  return acc;
}, {});

export default {
  name: 'LkNotificationsBroadcastsDialog',
  components: { BaseDeleteModal },
  mixins: [ruDateFormatMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      deletingId: null,
      deletingOld: false,
      confirmDialog: false,
      confirmTitle: '',
      confirmText: '',
      confirmSubmitText: 'Удалить',
      confirmMode: null,
      pendingBroadcast: null,
    };
  },
  computed: {
    ...mapGetters({
      broadcasts: 'LkNotifications/broadcasts',
      broadcastsLoading: 'LkNotifications/broadcastsLoading',
    }),
    fullyReadBroadcastsCount () {
      return this.broadcasts.filter(
        item => isBroadcastFullyRead(item) && this.recordId(item),
      ).length;
    },
  },
  watch: {
    value (open) {
      if (open) {
        this.loadBroadcasts();
      }
    },
  },
  methods: {
    ...mapActions({
      fetchBroadcasts: 'LkNotifications/fetchBroadcasts',
      destroyNotification: 'LkNotifications/destroyNotification',
      destroyReadNotifications: 'LkNotifications/destroyReadNotifications',
    }),
    close () {
      this.$emit('input', false);
    },
    loadBroadcasts () {
      this.fetchBroadcasts({ limit: 100 })
        .catch(() => {
          this.$flash_warning('Не удалось загрузить список рассылок');
        });
    },
    recordId (item) {
      return resolveLkNotificationId(item);
    },
    recipientsCount (item) {
      return item.recipients_count != null ? item.recipients_count : 0;
    },
    readCount (item) {
      return item.read_count != null ? item.read_count : 0;
    },
    unreadCount (item) {
      return item.unread_count != null ? item.unread_count : 0;
    },
    readStatusText (item) {
      return formatBroadcastReadStatus(item);
    },
    readStatusColor (item) {
      return getBroadcastReadStatusColor(item);
    },
    readStatusTextColor (item) {
      const color = this.readStatusColor(item);
      if (color === 'error' || color === 'success' || color === 'orange') {
        return 'white';
      }
      return 'grey darken-3';
    },
    typeIcon (type) {
      return getNotificationTypeIcon(type);
    },
    typeIconColor (type) {
      return getNotificationTypeColor(type);
    },
    typeChipColor (type) {
      return getNotificationTypeChipColor(type);
    },
    typeLabel (type) {
      return getNotificationTypeLabel(type);
    },
    formatDate (value) {
      if (!value) return '—';
      return this.ruDateFormat(value);
    },
    // formatRecipientsShort (recipients) {
    // if (!recipients || (!recipients.roles?.length && !recipients.user_ids?.length)) {
    //  return 'Всем ЛК';
    // }
    // const parts = [];
    // if (recipients.roles?.length) {
    //  parts.push(`${recipients.roles.length} ролей`);
    // }
    // if (recipients.user_ids?.length) {
    //  parts.push(`${recipients.user_ids.length} польз.`);
    // }
    //  return parts.join(', ');
    // },
    formatRecipientsFull (recipients) {
      if (!recipients || (!recipients.roles?.length && !recipients.user_ids?.length)) {
        return 'Все пользователи личного кабинета';
      }
      const parts = [];
      if (recipients.roles?.length) {
        const roles = recipients.roles
          .map(role => ROLE_LABEL_BY_VALUE[role] || role)
          .join(', ');
        parts.push(`Роли: ${roles}`);
      }
      if (recipients.user_ids?.length) {
        parts.push(`Пользователи (ID): ${recipients.user_ids.join(', ')}`);
      }
      return parts.join(' · ');
    },
    openDeleteOneConfirm (item) {
      const id = this.recordId(item);
      if (!id) {
        this.$flash_warning('Не удалось определить ID записи для удаления');
        return;
      }
      this.pendingBroadcast = item;
      this.confirmMode = 'one';
      this.confirmTitle = 'Удалить рассылку?';
      this.confirmText = `Рассылка «${item.title}» будет удалена у всех получателей (${this.recipientsCount(item)} чел.).`;
      this.confirmSubmitText = 'Удалить';
      this.confirmDialog = true;
    },
    openDeleteReadConfirm () {
      this.pendingBroadcast = null;
      this.confirmMode = 'read';
      this.confirmTitle = 'Удалить полностью прочитанные?';
      this.confirmText = `Будет удалено рассылок, которые прочитали все получатели: ${this.fullyReadBroadcastsCount}. Действие необратимо.`;
      this.confirmSubmitText = 'Удалить';
      this.confirmDialog = true;
    },
    confirmAction () {
      this.confirmDialog = false;
      if (this.confirmMode === 'read') {
        this.submitDeleteRead();
      } else if (this.pendingBroadcast) {
        this.submitDeleteOne(this.pendingBroadcast);
      }
    },
    submitDeleteOne (item) {
      const id = this.recordId(item);
      if (!id) {
        this.$flash_warning('Не удалось определить ID записи для удаления');
        return;
      }
      this.deletingId = id;
      this.destroyNotification(item)
        .then(() => {
          this.$flash_success('Рассылка удалена');
          this.$emit('deleted');
        })
        .catch(() => {
          this.$flash_warning('Не удалось удалить уведомление');
        })
        .finally(() => {
          this.deletingId = null;
          this.pendingBroadcast = null;
        });
    },
    submitDeleteRead () {
      this.deletingOld = true;
      const count = this.fullyReadBroadcastsCount;
      this.destroyReadNotifications()
        .then(() => {
          this.$flash_success(`Удалено рассылок: ${count}`);
          this.$emit('deleted');
        })
        .catch(() => {
          this.$flash_warning('Не удалось удалить прочитанные уведомления');
        })
        .finally(() => {
          this.deletingOld = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.lk-broadcasts-dialog__title {
  flex-wrap: wrap;
  gap: 8px;
}

.lk-broadcasts-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
}

.lk-broadcasts-dialog__panels {
  border-radius: 0;
}

.lk-broadcasts-dialog__panel-header {
  min-height: 64px !important;
}

.lk-broadcasts-dialog__panel-header-inner {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
}

.lk-broadcasts-dialog__panel-summary {
  flex: 1;
  min-width: 0;
  padding-right: 4px;
}

.lk-broadcasts-dialog__details {
  padding: 4px 0 8px;
}

.lk-broadcasts-dialog__detail-row {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  @media (min-width: 600px) {
    flex-direction: row;
    gap: 12px;
  }
}

.lk-broadcasts-dialog__detail-label {
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgba(0, 0, 0, 0.45);
  min-width: 120px;
}

.lk-broadcasts-dialog__detail-text {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;
}
</style>
